// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner[data-v-9e5ae972]{display:block}.banner[data-v-9e5ae972] code{padding:0 3px;margin:0 3px}", ""]);
// Exports
module.exports = exports;
